<template>
  <div class="checkin-manage">
    <el-card shadow="never">
      <div slot="header">
        <span>签到记录管理</span>
      </div>

      <!-- 筛选 -->
      <div class="filter-bar">
        <el-select v-model="filter.category_id" placeholder="选择栏目" clearable @change="loadData">
          <el-option
            v-for="cat in categories"
            :key="cat.id"
            :label="cat.name"
            :value="cat.id"
          ></el-option>
        </el-select>
        <el-date-picker
          v-model="filter.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          @change="loadData"
        ></el-date-picker>
      </div>

      <!-- 表格 -->
      <el-table :data="checkinList" border style="width: 100%" v-loading="loading">
        <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
        <el-table-column label="签到照片" width="120" align="center">
          <template slot-scope="scope">
            <el-image
              style="width: 80px; height: 80px"
              :src="getFullUrl(scope.row.photo_url)"
              fit="cover"
              :preview-src-list="[getFullUrl(scope.row.photo_url)]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="user_name" label="用户" width="120">
          <template slot-scope="scope">
            {{ scope.row.user_name || '未知用户' }}
          </template>
        </el-table-column>
        <el-table-column prop="category_name" label="栏目" width="150">
          <template slot-scope="scope">
            <el-tag size="small">{{ scope.row.category_name || '未知栏目' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="checkin_time" label="签到时间" width="180">
          <template slot-scope="scope">
            {{ formatTime(scope.row.checkin_time) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="viewDetail(scope.row)">
              查看
            </el-button>
            <el-button type="text" size="small" style="color: #f56c6c" @click="handleDelete(scope.row.id)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page="page"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 详情弹窗 -->
    <el-dialog title="签到详情" :visible.sync="detailVisible" width="500px">
      <div class="detail-content" v-if="currentRecord">
        <div class="detail-photo">
          <el-image
            style="max-width: 100%; max-height: 400px"
            :src="getFullUrl(currentRecord.photo_url)"
            fit="contain"
            :preview-src-list="[getFullUrl(currentRecord.photo_url)]"
          ></el-image>
        </div>
        <div class="detail-info">
          <div class="info-item">
            <label>用户：</label>
            <span>{{ currentRecord.user_name || '未知用户' }}</span>
          </div>
          <div class="info-item">
            <label>栏目：</label>
            <span>{{ currentRecord.category_name || '未知栏目' }}</span>
          </div>
          <div class="info-item">
            <label>签到时间：</label>
            <span>{{ formatTime(currentRecord.checkin_time) }}</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import config from '@/config'

export default {
  name: 'CheckinManage',
  data() {
    return {
      loading: false,
      checkinList: [],
      page: 1,
      pageSize: 20,
      total: 0,
      filter: {
        category_id: '',
        dateRange: []
      },
      detailVisible: false,
      currentRecord: null,
      staticUrl: config.staticUrl
    }
  },
  computed: {
    ...mapState(['categories'])
  },
  created() {
    this.loadData()
    this.$store.dispatch('fetchCategories')
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const { api } = await import('@/services/api')
        const params = {
          page: this.page,
          page_size: this.pageSize
        }
        if (this.filter.category_id) {
          params.category_id = this.filter.category_id
        }
        
        const response = await api.checkin.list(params)
        if (response.code === 200) {
          this.checkinList = response.data.list || []
          this.total = response.data.total || 0
        }
      } catch (error) {
        this.$message.error('加载数据失败：' + error.message)
      } finally {
        this.loading = false
      }
    },
    getFullUrl(url) {
      if (!url) return ''
      if (url.startsWith('http://') || url.startsWith('https://')) {
        return url
      }
      return this.staticUrl + url
    },
    formatTime(time) {
      if (!time) return '-'
      return time.replace('T', ' ').substring(0, 19)
    },
    handlePageChange(page) {
      this.page = page
      this.loadData()
    },
    viewDetail(record) {
      this.currentRecord = record
      this.detailVisible = true
    },
    async handleDelete(id) {
      try {
        await this.$confirm('确定删除此签到记录吗？', '提示', {
          type: 'warning'
        })
        const { api } = await import('@/services/api')
        const response = await api.checkin.delete(id)
        if (response.code === 200) {
          this.$message.success('删除成功')
          this.loadData()
        } else {
          this.$message.error(response.message || '删除失败')
        }
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error('删除失败')
        }
      }
    }
  }
}
</script>

<style scoped>
.checkin-manage {
  padding: 20px;
}

.filter-bar {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
}

.pagination-wrap {
  margin-top: 20px;
  text-align: right;
}

.detail-photo {
  text-align: center;
  margin-bottom: 20px;
}

.detail-info {
  padding: 0 20px;
}

.info-item {
  display: flex;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.info-item:last-child {
  border-bottom: none;
}

.info-item label {
  width: 80px;
  color: #999;
}

.info-item span {
  flex: 1;
  color: #333;
}
</style>
